import { render } from "./SimpleAiButton.vue?vue&type=template&id=35449b61&scoped=true"
import script from "./SimpleAiButton.vue?vue&type=script&lang=js"
export * from "./SimpleAiButton.vue?vue&type=script&lang=js"

import "./SimpleAiButton.vue?vue&type=style&index=0&id=35449b61&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35449b61"],['__file',"src/scripts/common/components/SimpleAiButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35449b61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35449b61', __exports__)) {
    api.reload('35449b61', __exports__)
  }
  
  module.hot.accept("./SimpleAiButton.vue?vue&type=template&id=35449b61&scoped=true", () => {
    api.rerender('35449b61', render)
  })

}


export default __exports__